var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          dense: true,
          title: "Resumen del Documento",
          breadcrumbs: _vm.breadcrumbs,
          breadcrumbsItemDinamic: {
            loading: _vm.$store.state.purchases.retrieveLoader,
            text: `${(_vm.activeDocument || {}).name} Nº ${
              _vm.instance.number
            }`,
          },
          hiddenTab: true,
          addPadding: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "mr-2",
                    attrs: { outlined: "" },
                    on: { click: _vm.retrieve },
                  },
                  [
                    _c("v-img", {
                      attrs: {
                        contain: "",
                        src: require(`@/assets/icon-update${
                          _vm.$vuetify.theme.dark ? "-dark" : ""
                        }.svg`),
                      },
                    }),
                  ],
                  1
                ),
                _vm.instance?.status === "APR"
                  ? [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            outlined: "",
                            ripple: false,
                            disabled: _vm.isAcceptDisabled,
                          },
                          on: { click: _vm.handleAcceptClick },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-file-document-check"),
                          ]),
                          _vm._v(" Aceptar "),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            color: "grey-900",
                            ripple: false,
                            disabled: _vm.isRejectDisabled,
                          },
                          on: { click: _vm.handleRejectClick },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-file-document-remove"),
                          ]),
                          _vm._v(" Rechazar "),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-col",
        { staticClass: "px-0", staticStyle: { "z-index": "0" } },
        [
          _vm.$store.state.purchases.retrieveLoader
            ? _c("skeleton-detail")
            : _c("div", { staticClass: "d-flex" }, [
                _c(
                  "div",
                  {
                    staticClass: "mr-6",
                    staticStyle: { "min-width": "425px" },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { position: "fixed!important" } },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "grey-900 pb-4",
                            attrs: { width: "425" },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "px-4 pt-4 subtitle-2 white--text font-weight-bold d-inline-block text-truncate",
                                staticStyle: { "max-width": "400px" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("nameDocumentsType")(
                                        _vm.instance.type
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "px-4 mt-n2 subtitle-2 white--text d-block",
                              },
                              [_vm._v(_vm._s(`Nº ${_vm.instance.number}`))]
                            ),
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  color: "white-0",
                                  right: "",
                                  "max-width": "185px",
                                  transition: "scale-transition",
                                  "open-delay": "1000",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "span",
                                          _vm._g(
                                            {
                                              staticClass:
                                                "px-4 mt-4 d-block white--text body-1 d-inline-block text-truncate",
                                              staticStyle: {
                                                "max-width": "98%",
                                              },
                                            },
                                            _vm.instance?.supplier?.name
                                              ?.length > 40
                                              ? on
                                              : false
                                          ),
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.instance?.supplier_name
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "d-block px-3 py-2" },
                                  [_vm._v(_vm._s(_vm.instance?.supplier_name))]
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "px-4 subtitle-2 font-weight-bold white--text",
                              },
                              [_vm._v(_vm._s(_vm.instance?.tax_id))]
                            ),
                            _c(
                              "v-row",
                              {
                                staticClass: "ml-2 mt-3",
                                attrs: { align: "end", "no-gutters": "" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "py-0 px-2",
                                    attrs: { cols: "5" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-block body-1 white--text",
                                      },
                                      [_vm._v("Fecha del doc.")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "subtitle-2 white--text" },
                                      [
                                        _vm.instance.date
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("date")(
                                                      _vm.instance.date
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 white--text font-italic",
                                              },
                                              [_vm._v("Sin especificar")]
                                            ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "py-0 px-2",
                                    attrs: { cols: "6" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-block body-1 white--text",
                                      },
                                      [_vm._v("Fecha de recepción en SII")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "subtitle-2 white--text" },
                                      [
                                        _vm.instance.rec_date
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("dateTimeSecond")(
                                                      _vm.instance.rec_date
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 white--text font-italic",
                                              },
                                              [_vm._v("Sin especificar")]
                                            ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        (_vm.instance.assignee_tax_id ||
                          _vm.instance.assignment_agency_status) &&
                        _vm.$store?.state?.auth?.account?.country === "CL"
                          ? _c(
                              "v-card",
                              {
                                staticClass: "mt-4 py-3",
                                staticStyle: {
                                  "border-color": "var(--grey-900)",
                                },
                                attrs: { color: "green-50", outlined: "" },
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "px-5",
                                    attrs: {
                                      align: "center",
                                      "no-gutters": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2",
                                        attrs: {
                                          size: "18",
                                          color: "grey-900",
                                        },
                                      },
                                      [_vm._v("mdi-file-arrow-left-right")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "subtitle-2 grey-900--text font-weight-bold",
                                      },
                                      [_vm._v("Información de cesión")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "px-5 mt-2",
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _c("v-col", { staticClass: "pa-0" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-block body-1 grey-900--text",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.instance.assignee_name ||
                                                "Sin definir"
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "subtitle-2 grey-900--text font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatRut(
                                                _vm.instance.assignee_tax_id
                                              ) || "Sin definir"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "v-col",
                                      { staticClass: "pa-0 text-right" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-block body-1 grey-900--text",
                                          },
                                          [_vm._v("Fecha de cesión")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "subtitle-2 grey-900--text font-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("dateTimeSecond")(
                                                  _vm.instance.assignment_date
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-card",
                          {
                            staticClass: "pa-0 mt-4",
                            staticStyle: { position: "fixed!important" },
                            attrs: {
                              width: "425",
                              transition: "slide-y-transition",
                              "min-height": "calc(100% - 365px)",
                              flat: "",
                            },
                          },
                          [
                            _c(
                              "v-toolbar",
                              {
                                attrs: {
                                  color: "transparent",
                                  flat: "",
                                  height: "46",
                                },
                              },
                              [
                                _c(
                                  "v-toolbar-title",
                                  {
                                    staticClass:
                                      "px-4 subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          size: "18",
                                          left: "",
                                          color: "grey-500",
                                        },
                                      },
                                      [_vm._v("mdi-currency-usd")]
                                    ),
                                    _vm._v("Totales"),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("v-divider"),
                            _c(
                              "v-card-text",
                              {
                                staticClass: "overflow-y-auto pa-0",
                                style:
                                  _vm.$vuetify.breakpoint.height <= 700
                                    ? "max-height: calc(100vh - 460px)"
                                    : "max-height: calc(100vh - 300px)",
                              },
                              [
                                _c(
                                  "v-col",
                                  { staticClass: "px-4" },
                                  [
                                    _c(
                                      "v-list",
                                      {
                                        staticClass: "transparent pa-0",
                                        attrs: { width: "100%" },
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "d-flex align-center",
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "16",
                                                      left: "",
                                                      color: "grey-500",
                                                    },
                                                  },
                                                  [_vm._v("mdi-currency-usd")]
                                                ),
                                                _vm._v("Subtotal"),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              {
                                                staticClass:
                                                  "text-right font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$fmt.currency(
                                                      _vm.documentCurrency,
                                                      _vm.instance
                                                        .amount_subtotal || 0
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "d-flex align-center",
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "16",
                                                      left: "",
                                                      color: "grey-500",
                                                    },
                                                  },
                                                  [_vm._v("mdi-sale")]
                                                ),
                                                _vm._v("Descuento"),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              {
                                                staticClass:
                                                  "text-right grey-500--text font-weight-bold",
                                              },
                                              [
                                                _vm.instance.amount_discount
                                                  ? [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$fmt.currency(
                                                            _vm.documentCurrency,
                                                            _vm.instance
                                                              .amount_discount
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  : [_vm._v("-")],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        (_vm.activeDocument || {})
                                          .has_taxes_detail
                                          ? [
                                              _c(
                                                "v-list-item",
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      staticClass:
                                                        "d-flex align-center",
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            size: "16",
                                                            left: "",
                                                            color: "grey-500",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-hand-coin"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v("Exento"),
                                                    ],
                                                    1
                                                  ),
                                                  _vm.instance.amount_exempt
                                                    ? _c(
                                                        "v-list-item-subtitle",
                                                        {
                                                          staticClass:
                                                            "text-right grey-500--text font-weight-bold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$fmt.currency(
                                                                _vm.documentCurrency,
                                                                _vm.instance
                                                                  .amount_exempt
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : [_vm._v("-")],
                                                ],
                                                2
                                              ),
                                              _vm.activeDocument.has_taxes
                                                ? [
                                                    _c(
                                                      "v-list-item",
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "d-flex align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  size: "16",
                                                                  left: "",
                                                                  color:
                                                                    "grey-500",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-hand-coin"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v("Neto"),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "text-right grey-500--text font-weight-bold",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$fmt.currency(
                                                                  _vm.documentCurrency,
                                                                  _vm.instance
                                                                    .amount_net
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-list-item",
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "d-flex align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  size: "16",
                                                                  left: "",
                                                                  color:
                                                                    "grey-500",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-cash-plus"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              "Impuestos (" +
                                                                _vm._s(
                                                                  _vm
                                                                    .activeDocument
                                                                    .tax_percent
                                                                ) +
                                                                "%)"
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "text-right grey-500--text font-weight-bold",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$fmt.currency(
                                                                  _vm.documentCurrency,
                                                                  _vm.instance
                                                                    .amount_tax ||
                                                                    0
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ]
                                          : _vm._e(),
                                        _c(
                                          "v-list-item",
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text font-weight-bold",
                                              },
                                              [_vm._v("Total documento")]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              {
                                                staticClass:
                                                  "text-right subtitle-2 grey-500--text font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$fmt.currency(
                                                      _vm.documentCurrency,
                                                      _vm.instance.amount_total
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "pb-5",
                    staticStyle: { flex: "1", "min-width": "180px" },
                  },
                  [
                    _c(
                      "v-alert",
                      {
                        staticClass:
                          "inf-alert-blue green-500--text rounded-md mb-3",
                        attrs: { height: 76, dense: "", text: "" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex pa-0 align-center" },
                          [
                            _c("v-icon", { attrs: { color: "green-500" } }, [
                              _vm._v("mdi-information-outline"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "ml-4 text-description" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "body-1 font-weight-bold" },
                                  [_vm._v("Documento de compras en SII")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "d-block body-2 pb-1" },
                                  [
                                    _vm._v(
                                      " Este documento fue obtenido del registro de compras del SII. "
                                    ),
                                    _c("span", { staticClass: "d-block" }, [
                                      _vm._v(
                                        "Por favor solicita el documento XML al proveedor."
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c("v-spacer"),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm.instance.status === "PEN" && _vm.daysLeftAlert > 0
                      ? _c(
                          "v-alert",
                          {
                            staticClass: "mb-5",
                            class:
                              _vm.daysLeftAlert >= 5
                                ? "inf-alert-blue green-500--text"
                                : "inf-alert-yellow yellow-500--text",
                            attrs: {
                              "rounded-md": "",
                              dense: "",
                              text: "",
                              outlined: "",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex pa-0 my-1 alert-conten" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color:
                                        _vm.daysLeftAlert >= 5
                                          ? "green-500"
                                          : "yellow-500",
                                      size: "22",
                                    },
                                  },
                                  [_vm._v("mdi-calendar-alert")]
                                ),
                                _c("div", { staticClass: "ml-4" }, [
                                  _c(
                                    "span",
                                    { staticClass: "body-1 font-weight-bold" },
                                    [_vm._v("Días restantes")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "d-block body-2",
                                      staticStyle: { "line-height": "14px" },
                                    },
                                    [
                                      _vm._v(
                                        " Te queda" +
                                          _vm._s(
                                            _vm.daysLeftAlert > 1 ? "n" : ""
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$fmt.integer(
                                                _vm.daysLeftAlert
                                              )
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.daysLeftAlert > 1
                                                  ? "días"
                                                  : "día"
                                              )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " para la respuesta comercial del documento "
                                      ),
                                      _vm.btnDisable >= 7
                                        ? _c(
                                            "span",
                                            { staticClass: "d-block mt-1" },
                                            [
                                              _vm._v(
                                                " Si deseas aceptar o reclamar este documento, deberá hacerlo directamente en el SII. "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "v-card",
                      { staticClass: "mb-5", attrs: { flat: "" } },
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              color: "transparent",
                              flat: "",
                              height: "46",
                            },
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              {
                                staticClass:
                                  "px-5 subtitle-2 grey-700--text font-weight-bold",
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    attrs: {
                                      "no-gutters": "",
                                      align: "center",
                                      justify: "space-between",
                                    },
                                  },
                                  [
                                    _c("v-col", { staticClass: "pa-0" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "ml-n1 subtitle-2 grey-700--text font-weight-semibold",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-2 mt-n1",
                                              attrs: {
                                                small: "",
                                                color: "grey-700",
                                              },
                                            },
                                            [_vm._v("mdi-shield-check")]
                                          ),
                                          _vm._v("Estado comercial "),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                        _c(
                          "v-card-text",
                          { staticClass: "px-0 py-4" },
                          [
                            _vm.loadingSwap
                              ? _c("v-skeleton-loader", {
                                  staticClass: "rounded-md",
                                  attrs: { type: "list-item-three-line" },
                                })
                              : _c(
                                  "v-list",
                                  {
                                    staticClass:
                                      "v-list-form-2-actions transparent pa-0",
                                    attrs: { width: "100%" },
                                  },
                                  [
                                    _c(
                                      "v-list-item",
                                      { staticClass: "px-5" },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass:
                                              "grey-500--text subtitle-2",
                                          },
                                          [_vm._v("Estado")]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          [
                                            _c("chip-status", {
                                              attrs: {
                                                status:
                                                  _vm.instance?.rec_status ||
                                                  "PEN",
                                                detail: _vm.instance
                                                  ?.rec_status_info
                                                  ? _vm.instance
                                                      ?.rec_status_info
                                                  : null,
                                                showDetail: true,
                                                type: "purchases",
                                                isTooltip: true,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-divider", { staticClass: "my-5" }),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "px-5" },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass:
                                              "grey-500--text subtitle-2",
                                          },
                                          [
                                            _vm._v(
                                              "Estado " +
                                                _vm._s(_vm.$t("generals.SII"))
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          [
                                            _c("chip-status", {
                                              attrs: {
                                                status: _vm.instance?.status,
                                                showDetail: true,
                                                type: "documents",
                                                isTooltip: false,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item-action",
                                          {
                                            staticClass: "ma-0",
                                            staticStyle: { overflow: "hidden" },
                                          },
                                          [
                                            [
                                              "FAI",
                                              "SNT",
                                              "CRE",
                                              "ART",
                                              "MRT",
                                            ].includes(_vm.instance?.status)
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "btnText",
                                                    attrs: {
                                                      disabled:
                                                        _vm.disabledUpdate,
                                                      text: "",
                                                      color: "grey-900",
                                                      ripple: false,
                                                    },
                                                    on: {
                                                      click: _vm.reprocessDoc,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          left: "",
                                                          color: "grey-900",
                                                        },
                                                      },
                                                      [_vm._v("mdi-refresh")]
                                                    ),
                                                    _vm._v(
                                                      " Actualizar estado "
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    ![
                                      "FAI",
                                      "SNT",
                                      "CRE",
                                      "ART",
                                      "MRT",
                                    ].includes(_vm.instance?.status) &&
                                    _vm.instance.validation_date
                                      ? _c(
                                          "v-list-item",
                                          { staticClass: "px-5" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [_vm._v("Fecha de validación")]
                                            ),
                                            _c("v-list-item-subtitle", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("dateTimeSecond")(
                                                      _vm.instance
                                                        .validation_date
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-card",
                      { staticClass: "mt-5", attrs: { flat: "" } },
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              color: "transparent",
                              flat: "",
                              height: "46",
                            },
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              {
                                staticClass:
                                  "px-5 subtitle-2 grey-700--text font-weight-semibold",
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      size: "18",
                                      left: "",
                                      color: "grey-700",
                                    },
                                  },
                                  [_vm._v("mdi-timeline-clock")]
                                ),
                                _vm._v("Eventos"),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.eventLoading
                          ? _c("v-skeleton-loader", {
                              staticClass: "mb-2 panel px-1 rounded-md",
                              attrs: {
                                transition: "fade-transition",
                                type: "list",
                              },
                            })
                          : (_vm.eventsList || []).length
                          ? [
                              _c("v-divider"),
                              _c(
                                "v-card-text",
                                { staticClass: "pa-0" },
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass:
                                        "transparent px-0 py-2 dense",
                                    },
                                    [
                                      _vm._l(_vm.events, function (d, i) {
                                        return _c(
                                          "div",
                                          { key: i },
                                          [
                                            _c(
                                              "v-list-item",
                                              {
                                                key: i,
                                                staticClass: "px-5 py-0",
                                              },
                                              [
                                                _c(
                                                  "v-list-item-icon",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "green-500",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentEvent(
                                                              d.rec_event_type
                                                            ).icon
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-list-item-title",
                                                  { staticClass: "ml-n5" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-flex grey-700--text body-1",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "font-weight-medium",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.currentEvent(
                                                                  d.rec_event_type
                                                                ).summary
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        d.description
                                                          ? [
                                                              _c("v-divider", {
                                                                staticClass:
                                                                  "mx-2 my-1",
                                                                attrs: {
                                                                  vertical: "",
                                                                },
                                                              }),
                                                              d.description
                                                                .length < 30
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-body-2 grey-700--text",
                                                                      staticStyle:
                                                                        {
                                                                          "margin-top":
                                                                            "2px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          d.description
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "grey-background",
                                                                        right:
                                                                          "",
                                                                        transition:
                                                                          "scale-transition",
                                                                        width:
                                                                          "500",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "activator",
                                                                              fn: function ({
                                                                                on,
                                                                              }) {
                                                                                return [
                                                                                  _c(
                                                                                    "v-sheet",
                                                                                    _vm._g(
                                                                                      {
                                                                                        staticClass:
                                                                                          "grey-700--text",
                                                                                        attrs:
                                                                                          {
                                                                                            width:
                                                                                              "100%",
                                                                                            height:
                                                                                              "20",
                                                                                          },
                                                                                      },
                                                                                      on
                                                                                    ),
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "d-inline-block text-truncate text-body-2",
                                                                                          staticStyle:
                                                                                            {
                                                                                              "max-width":
                                                                                                "90%",
                                                                                              "margin-top":
                                                                                                "2px",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                d.description
                                                                                              ) +
                                                                                              " "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "d-block px-3 py-2",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              d.description
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-block body-2 grey-300--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateTimeSecond"
                                                            )(d.created)
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            i !== _vm.eventsList.length - 1
                                              ? _c(
                                                  "v-sheet",
                                                  {
                                                    staticClass:
                                                      "text-left ml-8 mt-n4 mb-n2",
                                                    attrs: { height: "18" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          position: "absolute",
                                                          left: "30px",
                                                        },
                                                        attrs: {
                                                          size: "3",
                                                          color: "placeholder",
                                                        },
                                                      },
                                                      [_vm._v("mdi-circle")]
                                                    ),
                                                    _c("v-divider", {
                                                      staticClass: "my-0",
                                                      attrs: { vertical: "" },
                                                    }),
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mb-n1",
                                                        staticStyle: {
                                                          left: "-1px",
                                                          top: "7px",
                                                        },
                                                        attrs: {
                                                          size: "3",
                                                          color: "placeholder",
                                                        },
                                                      },
                                                      [_vm._v("mdi-circle")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }),
                                      _vm.eventsList.length > 3
                                        ? [
                                            _c("v-divider", {
                                              staticClass: "mt-4",
                                            }),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "mt-1 mb-n1 mx-5",
                                                attrs: {
                                                  color: "grey-900",
                                                  text: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.showMoreEvents =
                                                      !_vm.showMoreEvents
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      !_vm.showMoreEvents
                                                        ? "Ver todos los eventos"
                                                        : "Ver menos eventos"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
        ],
        1
      ),
      _vm.$store.state.auth.account.country === "PE"
        ? _c(
            "v-dialog",
            {
              attrs: {
                width: "410",
                persistent: "",
                "no-click-animation": "",
                "overlay-color": "grey-500",
              },
              model: {
                value: _vm.dialogSwap,
                callback: function ($$v) {
                  _vm.dialogSwap = $$v
                },
                expression: "dialogSwap",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: "transparent",
                          attrs: { flat: "", height: "46" },
                        },
                        [
                          _c(
                            "v-toolbar-title",
                            {
                              staticClass:
                                "px-5 subtitle-2 grey-700--text font-weight-semibold",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.dialogSwapType !== "reclaim"
                                    ? "Aceptar"
                                    : "Rechazar"
                                ) + " documento"
                              ),
                            ]
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-toolbar-items",
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "mr-3",
                                  attrs: { align: "center", justify: "center" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        small: "",
                                        "retain-focus-on-click": "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.dialogSwap = false
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: "grey-500",
                                            size: "20",
                                          },
                                        },
                                        [_vm._v("mdi-close")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-text",
                    { staticClass: "px-5 py-4" },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "pt-8",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require(`@/assets/backgrounds/modal-purchase-null.svg`),
                              width: 168,
                            },
                          }),
                        ]
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pt-8 px-0 pb-0" },
                        [
                          _c(
                            "v-list",
                            {
                              staticClass: "pa-0 transparent",
                              attrs: { "three-line": "" },
                            },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "pa-0" },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-subtitle",
                                        { staticClass: "pt-2" },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              "single-line": "",
                                              dense: "",
                                              "hide-details": "",
                                              placeholder: "Descripción",
                                            },
                                            model: {
                                              value:
                                                _vm.swapResponse
                                                  .rec_status_info,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.swapResponse,
                                                  "rec_status_info",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "swapResponse.rec_status_info",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    { staticClass: "py-2 px-5" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { outlined: "", color: "grey-700" },
                          on: {
                            click: function ($event) {
                              _vm.dialogSwap = false
                            },
                          },
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.loadingSwap,
                            color: "grey-900",
                          },
                          on: { click: _vm.updateSwap },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.dialogSwapType !== "reclaim"
                                ? "Aceptar"
                                : "Rechazar"
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.$store.state.auth.account.country === "CL"
        ? _c(
            "v-dialog",
            {
              attrs: {
                width: "600",
                persistent: "",
                "no-click-animation": "",
                "overlay-color": "grey-500",
              },
              model: {
                value: _vm.dialogCL,
                callback: function ($$v) {
                  _vm.dialogCL = $$v
                },
                expression: "dialogCL",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: "transparent",
                          attrs: { flat: "", height: "46" },
                        },
                        [
                          _c(
                            "v-toolbar-title",
                            {
                              staticClass:
                                "px-5 subtitle-2 grey-700--text font-weight-semibold",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.dialogCLType === "accept"
                                    ? "Aceptar"
                                    : "Rechazar"
                                ) + " documento"
                              ),
                            ]
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-toolbar-items",
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "mr-3",
                                  attrs: { align: "center", justify: "center" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        small: "",
                                        "retain-focus-on-click": "",
                                      },
                                      on: { click: _vm.closeCLDialog },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: "grey-500",
                                            size: "20",
                                          },
                                        },
                                        [_vm._v("mdi-close")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-text",
                    { staticClass: "px-5 py-2" },
                    [
                      _c(
                        "v-row",
                        { staticClass: "pt-2", attrs: { align: "center" } },
                        [
                          _c("v-col", { attrs: { cols: "4" } }, [
                            _c("img", {
                              attrs: {
                                src: require(`@/assets/backgrounds/${
                                  _vm.dialogCLType === "accept"
                                    ? "modal-cl-accept"
                                    : "modal-cl-claim"
                                }.svg`),
                                width: 148,
                              },
                            }),
                          ]),
                          _c(
                            "v-col",
                            { staticClass: "pr-4 pl-4" },
                            [
                              _c(
                                "v-list",
                                { staticClass: "v-list-form pa-0 transparent" },
                                [
                                  _c(
                                    "v-list-item",
                                    { staticClass: "pa-0 mb-3" },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c(
                                            "v-alert",
                                            {
                                              staticClass:
                                                "inf-alert-blue green-500--text rounded-md mb-3",
                                              attrs: {
                                                height:
                                                  _vm.dialogCLType === "accept"
                                                    ? 88
                                                    : 58,
                                                dense: "",
                                                text: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "d-flex pa-0" },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "green-500",
                                                        size: "22",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mdi-information-outline"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-4 text-description",
                                                    },
                                                    [
                                                      _vm.dialogCLType ===
                                                      "accept"
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Al aceptar un documento en el SII, entrega acuse de recibo de mercaderías y/o servicios, y pasa a formar parte de propuesta de pago de IVA. "
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Al rechazar un documento en el SII, quedará fuera de la propuesta de pago de IVA. "
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.dialogCLType === "accept"
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "mt-n4 d-block grey-500--text font-weight-semibold body-1",
                                      },
                                      [_vm._v("Acuse de recibo del documento")]
                                    ),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "pa-0 mt-n1" },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                                placeholder: "Recinto",
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.acceptRecinto,
                                                callback: function ($$v) {
                                                  _vm.acceptRecinto = $$v
                                                },
                                                expression: "acceptRecinto",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "mt-n4 d-block grey-500--text font-weight-semibold body-1",
                                      },
                                      [
                                        _vm._v(
                                          "Selecciona la respuesta al documento"
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "pa-0" },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                items: _vm.claimTypes,
                                                "item-text": "label",
                                                "item-value": "value",
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                                placeholder:
                                                  "Seleccione motivo",
                                              },
                                              model: {
                                                value: _vm.claimType,
                                                callback: function ($$v) {
                                                  _vm.claimType = $$v
                                                },
                                                expression: "claimType",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "pa-0" },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          { staticClass: "pt-0 mt-0" },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                                placeholder:
                                                  "Motivo de rechazo",
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.claimReason,
                                                callback: function ($$v) {
                                                  _vm.claimReason = $$v
                                                },
                                                expression: "claimReason",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    { staticClass: "py-2 px-5" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { outlined: "", ripple: false },
                          on: { click: _vm.closeCLDialog },
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "grey-900",
                            disabled:
                              _vm.dialogCLType === "accept"
                                ? !_vm.acceptRecinto
                                : !_vm.claimType || !_vm.claimReason,
                            loading: _vm.loadingSwap,
                            ripple: false,
                          },
                          on: {
                            click: function ($event) {
                              _vm.dialogCLType === "accept"
                                ? _vm.acceptDocumentCL()
                                : _vm.claimDocumentCL()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.dialogCLType === "accept"
                                  ? "Aceptar"
                                  : "Rechazar"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "838",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogConfirmSwap,
            callback: function ($$v) {
              _vm.dialogConfirmSwap = $$v
            },
            expression: "dialogConfirmSwap",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-300--text--grey-500 font-weight-semibold",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.dialogSwapType !== "reclaim"
                                ? "Aceptar"
                                : "Rechazar"
                            ) + " "
                          ),
                        ]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogConfirmSwap = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "grey-300--text",
                                        size: "20",
                                      },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-700--text" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-document-null.svg`),
                            width: 188,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-4 body-1 pl-6" },
                        [
                          _vm._v(" Se registrará el evento "),
                          _c(
                            "span",
                            { staticClass: "font-weight-bold text-lowercase" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.swapResponse.status.label ||
                                    _vm.swapStatuses[0].label
                                )
                              ),
                            ]
                          ),
                          _vm._v(
                            " en el registro de compras del " +
                              _vm._s(_vm.$t("generals.SII")) +
                              ", y se le enviará, una notificación al proveedor informando la respuesta del documento. "
                          ),
                          _c("span", { staticClass: "d-block body-1 pt-3" }, [
                            _vm._v(
                              "Al confirmar esta acción, no habrá vuelta atrás."
                            ),
                          ]),
                          _c(
                            "span",
                            { staticClass: "d-block body-1 mt-4 mb-3" },
                            [
                              _vm._v("Escribe "),
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v('"confirmar"'),
                              ]),
                              _vm._v(" para continuar."),
                            ]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              maxlength: "9",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.confirm,
                              callback: function ($$v) {
                                _vm.confirm = $$v
                              },
                              expression: "confirm",
                            },
                          }),
                          _c(
                            "v-alert",
                            {
                              staticClass:
                                "inf-alert-blue green-500--text rounded-md mt-4",
                              attrs: { height: 50, dense: "", text: "" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex pa-0 my-1 pt-1" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "green-500", size: "22" },
                                    },
                                    [_vm._v("mdi-information-outline")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "ml-4 text-description" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "body-2",
                                          staticStyle: {
                                            "line-height": "14px",
                                          },
                                        },
                                        [
                                          _vm._v("Esta acción "),
                                          _c(
                                            "span",
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                "podría tardar varios minutos"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" en completarse. "),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogConfirmSwap = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.$store.state.irs.createLoader,
                        disabled: _vm.confirm.toLowerCase() !== "confirmar",
                      },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialogSwap = false), _vm.updateSwap()
                        },
                      },
                    },
                    [_vm._v("Confirmar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            scrollable: true,
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.modalEmail,
            callback: function ($$v) {
              _vm.modalEmail = $$v
            },
            expression: "modalEmail",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { "min-height": "300px" } },
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold d-flex align-center",
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "grey-500", left: "" } },
                            [_vm._v("mdi-email")]
                          ),
                          _vm._v("Solicitar al proveedor"),
                        ],
                        1
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.modalEmail = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "transparent rounded-0 pa-0",
                          attrs: { flat: "" },
                        },
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "background pt-5 pb-3 px-5" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey-700--text body-1",
                                      staticStyle: { "min-width": "60px" },
                                    },
                                    [_vm._v("Para")]
                                  ),
                                  _c("v-combobox", {
                                    staticClass: "a-combobox",
                                    attrs: {
                                      error: _vm.$v.messages.recipient.$error,
                                      "hide-details": "",
                                      items: _vm.emails,
                                      outlined: "",
                                      required: "",
                                      "hide-selected": "",
                                      placeholder: !_vm.messages.recipient
                                        ? "Escribe el email del destinatario"
                                        : "",
                                      multiple: "",
                                      "hide-no-data": "",
                                      "deletable-chips": "",
                                      "small-chips": "",
                                      "single-line": "",
                                      dense: "",
                                      autocomplete: "off",
                                    },
                                    on: { change: _vm.setEmails },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "v-chip",
                                              _vm._b(
                                                {
                                                  staticClass: "pr-2 ma-1",
                                                  attrs: {
                                                    small: "",
                                                    "input-value":
                                                      data.selected,
                                                    close: "",
                                                  },
                                                  on: {
                                                    click: data.select,
                                                    "click:close": function (
                                                      $event
                                                    ) {
                                                      return _vm.remove(
                                                        data.item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-chip",
                                                data.attrs,
                                                false
                                              ),
                                              [_vm._v(_vm._s(data.item))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.$v.messages.recipient.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.messages.recipient,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "$v.messages.recipient.$model",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "d-flex align-center mt-3" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey-700--text body-1",
                                      staticStyle: { "min-width": "60px" },
                                    },
                                    [_vm._v("Asunto")]
                                  ),
                                  _c("v-text-field", {
                                    attrs: {
                                      error: _vm.$v.messages.subject.$error,
                                      outlined: "",
                                      required: "",
                                      "single-line": "",
                                      dense: "",
                                      maxlength: "60",
                                      hint: "Escribe un asunto para el mensaje",
                                      "persistent-hint": "",
                                      "hide-details":
                                        !_vm.$v.messages.subject.$error,
                                    },
                                    model: {
                                      value: _vm.$v.messages.subject.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.messages.subject,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression: "$v.messages.subject.$model",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-text",
                            {
                              staticClass:
                                "px-0 mt-2 mx-auto bgPanel overflow-y-auto text-center",
                              staticStyle: { "max-height": "450px" },
                            },
                            [
                              _c("v-alert", {
                                staticClass: "pa-0 mx-auto",
                                style: `width: ${
                                  _vm.$vuetify.breakpoint.width < 1270
                                    ? 465
                                    : 564
                                }px;`,
                                attrs: {
                                  border: "top",
                                  color: "var(--grey-900)",
                                  "colored-border": "",
                                  elevation: "0",
                                },
                              }),
                              _c(
                                "v-sheet",
                                {
                                  staticClass: "mx-auto",
                                  staticStyle: {
                                    "border-radius": "10px",
                                    "margin-top": "-17px",
                                  },
                                  attrs: {
                                    width:
                                      _vm.$vuetify.breakpoint.width < 1270
                                        ? 470
                                        : 570,
                                    outlined: "",
                                  },
                                },
                                [
                                  _c("reminder-documents-email", {
                                    attrs: {
                                      instance: _vm.instance,
                                      activeDocument: _vm.activeDocument,
                                      "color-background":
                                        _vm.account.color_background,
                                      message: _vm.messages.text,
                                    },
                                    on: {
                                      "update:message": function ($event) {
                                        return _vm.$set(
                                          _vm.messages,
                                          "text",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-4 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.modalEmail = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.$store.state.messages.createLoader,
                        color: "grey-900",
                      },
                      on: { click: _vm.createMessages },
                    },
                    [_vm._v("Enviar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }